const COLORS = ["#55BECD", "#7FD5E1", "#A48BE7", "#FF8967", "#8BA2E6", "#FFB067", "#A48BE7", "#FF8967", "#7495C6", "#FFAC67", "#67BCBC", "#FF8467", "#F2849C", "#D675B9", "#A074C8", "#D675B9", "#FF8967", "#FFA18B", "#FF8467", "#A074C8", "#67BCBC", "#FFBF67", "#7A87CA", "#6BAFBF", "#FFA18B", "#6BAFBF", "#7A87CA", "#A48BE7", "#7495C6", "#8BA2E6", "#F2849C", "#FFB067", "#55BECD", "#7FD5E1", "#FFAC67", "#FFBF67"];
export function stringToColor(str) {
  let hash = 0;
  if (str.length === 0) {
    return COLORS[0];
  }
  const whiteSpaceIndex = str.length;
  const picked = str.slice(0, whiteSpaceIndex);
  for (let i = 0; i < picked.length; i++) {
    hash = picked.charCodeAt(i) - "a".charCodeAt(0) + ((hash << 5) - hash);
    hash |= 0;
  }
  hash = (hash % COLORS.length + COLORS.length) % COLORS.length;
  return COLORS[hash];
}